import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivate,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { UserData } from './auth/userData';
import { Utility } from './utility/utility';
import { PermissionEnforcer } from './services/permission-enforcer.service';

@Injectable({
    providedIn: 'root',
})
export class AlreadyGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router,
        private userData: UserData,
        private utility: Utility,
        private permissionEnforcer: PermissionEnforcer,
    ) {}
    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        let rolePromise = this.userData.getRole();
        return rolePromise.then(async (role) => {
            if (!role) return true;

            const isInMobileView = this.utility.isInMobileView(); //window.innerWidth <= 700;

            if (await this.authService.getIsAuth()) {
                if (this.permissionEnforcer.hasPermission('AdminPanel', 'view')) {
                    this.router.navigate(['/register']);
                    return false;
                } else if (
                    this.permissionEnforcer.hasPermission('Attendance-Tutor', 'view') &&
                    isInMobileView
                ) {
                    this.router.navigate(['attendance-tutor']);
                    return false;
                } else if (
                    this.permissionEnforcer.hasPermission('Student-Course-Lessons', 'view')
                ) {
                    this.router.navigate(['student-course-lesson']);
                    return false;
                } else {
                    this.router.navigate(['/my-projects']);
                    return false;
                }
                // else if (hasPermission("student_das","edit") {}
                // if (role === 'admin' || role === 'projectadmin') {
                //     this.router.navigate(['/register']);
                //     return false;
                // } else if (role === 'tutor' && isInMobileView) {
                //     this.router.navigate(['attendance-tutor']);
                // } else {
                //     this.router.navigate(['/my-projects']);
                //     return false;
                // }
            } else {
                return true;
            }
        });
    }
}
